import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Search, X } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';
import PhoneFrame from '../components/PhoneFrame';
import StarField from '../components/StarField';
import { GalaxyMark } from '../components/OrbitLogo';

export default function Friends() {
  const nav = useNavigate();
  const { friends, removeFriendById } = useApp();
  const [pending, setPending] = useState({});

  const remove = async (friend) => {
    setPending((value) => ({ ...value, [friend.id]: true }));
    try {
      await removeFriendById(friend.id);
      toast(`${friend.name || friend.handle} left your orbit`);
    } catch (err) {
      toast(err.message || 'Could not update your orbit');
    } finally {
      setPending((value) => ({ ...value, [friend.id]: false }));
    }
  };

  return (
    <PhoneFrame>
      <div className="relative min-h-full">
        <StarField />
        <div className="relative z-10">
          <div className="orbit-page-header">
            <button className="press orbit-icon-button" onClick={() => nav(-1)} aria-label="Go back">
              <ArrowLeft />
            </button>
            <h1 className="font-display orbit-page-title flex-1 text-center">Your Orbit</h1>
            <button className="press orbit-icon-button" onClick={() => nav('/search')} aria-label="Search">
              <Search />
            </button>
          </div>

          <div className="p-4">
            {friends.length === 0 && (
              <div className="flex flex-col items-center py-10">
                <div className="floaty mb-3"><GalaxyMark size={44} /></div>
                <p className="text-center italic" style={{ color: '#6f6795' }}>Nobody in your orbit yet.</p>
                <button
                  onClick={() => nav('/search')}
                  className="press orbit-primary-button mt-4"
                >
                  Search the cosmos
                </button>
              </div>
            )}
            {friends.map((friend) => (
              <div key={friend.id} className="orbit-surface-card flex items-center gap-3 mb-3">
                {friend.avatar ? (
                  <img src={friend.avatar} alt="" className="w-12 h-12 rounded-full object-cover" style={{ border: '1px solid rgba(160,140,230,.4)' }} />
                ) : (
                  <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold" style={{ background: 'linear-gradient(135deg,#ff5bd1,#6b4fd6)', color: '#fff' }}>
                    {(friend.name || friend.handle || '?')[0]?.toUpperCase()}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate" style={{ color: '#f1ecff' }}>{friend.name || friend.handle}</div>
                  <div className="text-sm truncate" style={{ color: '#8079a6' }}>@{friend.handle}</div>
                </div>
                <button
                  onClick={() => remove(friend)}
                  disabled={pending[friend.id]}
                  className="press orbit-secondary-button !px-3"
                  style={{ opacity: pending[friend.id] ? 0.6 : 1 }}
                >
                  <X /> Unorbit
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PhoneFrame>
  );
}
